import React from 'react'
import styled from 'styled-components'
import useShop from '../context/AppContext'
import { images } from '../constants'
import { motion } from 'framer-motion'

const SectionWrapper = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  min-height: calc(100dvh - 100px);
  padding: 100px 0 150px;
  @media screen and (max-width: 1023px) {
    padding: 100px 0 150px;
  }
  @media screen and (max-width: 800px) {
    padding: 60px 0 130px;
  }
`
const SectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 86%;
  max-width: var(--max-width);
  margin: 0 auto;
  @media screen and (max-width: 800px) {
    flex-direction: column;
    width: calc(100% - 50px);
    margin: 0 25px;
  }
`
const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: calc(100% - 420px);
  height: 100%;
  padding-right: 80px;
  @media screen and (max-width: 1023px) {
    width: calc(100% - 320px);
    padding-right: 40px;
  }
  @media screen and (max-width: 800px) {
    width: 100%;
    padding-right: 0;
  }
  .shopify-icon {
    opacity. 0.9;
    height: 32px;
    margin-top: 35px;
  }
  h1 {
    line-height: 1.25;
    margin-bottom: 15px;
  }
  h3 {
    font-size:  var(--fz-lg);
    color: var(--text);
    line-height: 1.5;
    font-weight: 400;
    margin-bottom: 30px;
  }
`
const RightColumn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 420px;
  height: 380px;
  img {
    max-width: 480px;
  }
  @media screen and (max-width: 1023px) {
    width: 320px;
    img {
      max-width: 380px;
    }
  }
  @media screen and (max-width: 800px) {
    display: none;
  }
`

const ServiceHero = () => {
  const { preloaderExecuted, navigationExecuted } = useShop()

  const title = <h1>Shopify web design, development, marketing & consulting services.</h1>
  const subtitle = <h3>Shopify services can help your business take full advantage of one of the leading eCommerce platforms. If you want to build an online store for your business that really shines and reaches the largest possible audience, Shopify is one of the most popular options.</h3>
  const shopify = <img src={images.service_shopify} alt="Shopify" className="shopify-icon" />

  return (
    <SectionWrapper>
      <SectionContainer>
        {preloaderExecuted && navigationExecuted ? (
          <LeftColumn>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 0.1, duration: 0.3 }} className="start-opacity">
              {title}
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 0.2, duration: 0.3 }} className="start-opacity">
              {subtitle}
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 0.3, duration: 0.3 }} className="start-opacity">
              {shopify}
            </motion.div>
          </LeftColumn>
        ) : (
          <LeftColumn>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1, duration: 0.3 }} className="start-opacity">
              {title}
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1.1, duration: 0.3 }} className="start-opacity">
              {subtitle}
            </motion.div>
            <motion.div animate={{ y: [15, 0], opacity: [0, 1] }} transition={{ delay: 1.2, duration: 0.3 }} className="start-opacity">
              {shopify}
            </motion.div>
          </LeftColumn>
        )}
        {preloaderExecuted && navigationExecuted ? (
          <RightColumn>
            <motion.div animate={{ scale: [1.05, 1], opacity: [0, 1] }} transition={{ delay: 0.3, duration: 0.5 }} className="start-opacity">
              <img src={images.service_hero_image} alt="Invaders" />
            </motion.div>
          </RightColumn>
        ) : (
          <RightColumn>
            <motion.div animate={{ scale: [1.05, 1], opacity: [0, 1] }} transition={{ delay: 1.2, duration: 0.5 }} className="start-opacity">
              <img src={images.service_hero_image} alt="Invaders" />
            </motion.div>
          </RightColumn>
        )}
      </SectionContainer>
    </SectionWrapper>
  )
}

export default ServiceHero
